app.controller(
    'SetListController', ['$scope', '$rootScope', '$http', '$stateParams', '$timeout', 'toastr', '$document', 'Configuration', 'GroupService', '$sce', '$translate', 'SideBarService', 'HelperService', '$window', 'AdminService', SetListController]
);

function SetListController($scope, $rootScope, $http, $stateParams, $timeout, toastr, $document, Configuration, GroupService, $sce, $translate, SideBarService, HelperService, $window, AdminService) {
    var vm = this;
    vm.isAllSelected = false;
    $scope.$parent.type = 'set';
    $translate.use($rootScope.LangForInterface);

    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
    }

    if ($stateParams.qc) {
        vm.ParamQcId = $stateParams.qc;
    }
    else {
        vm.ParamQcId = 10585;
    }


    $rootScope.UpdateRoles();

    vm.GroupList = []; //declare an empty array
    vm.pageno = 1; // initialize page no to 1
    vm.total_count = 0;
    vm.sortKey = "GroupTitle";
    vm.direction = "ascending";
    vm.reverse = false;
    vm.SearchVM = {};
    $rootScope.TopBarAction = {};
    $rootScope.TopBarAction.isActive = false;
    $rootScope.BatchReplaceTextResult = null;
    vm.itemsPerPage = 10; //this could be a dynamic value from a drop down

    vm.getsearchurlparam = function (zoneId, pageno, sortKey, reverse, isTopBarActive, searchText, SearchVM) { // This would fetch the data on page change.
        if (SearchVM.Reset) {
            vm.SearchParam = "";
        }
        else {
            vm.SearchParam = HelperService.GetSearchUrlParam(SearchVM);
        }
        SearchVM.Reset = false;
        $window.location.href = $rootScope.interfaceSubFolder + '/#!/list/set?z=' + zoneId + '&qc=' + vm.ParamQcId + '&pageno=' + pageno + '&sortkey=' + sortKey + '&reverse=' + reverse + '&istopbaractive=' + isTopBarActive + '&searchText=' + searchText + vm.SearchParam;        
    };



    vm.getDataV2 = function () { // This would fetch the data on page change.
        //In practice this should be in a factory.
        vm.GroupList = [];

        if ($stateParams.z != null)
            vm.ParamZoneId = $stateParams.z;

        if ($stateParams.pageno != null)
            vm.pageno = $stateParams.pageno;

        if ($stateParams.reverse != null)
            vm.reverse = $stateParams.reverse;

        if ($stateParams.sortkey != null)
            vm.sortKey = $stateParams.sortkey;

        if ($stateParams.istopbaractive != null)
            $rootScope.TopBarAction.isActive = $stateParams.istopbaractive;

        if ($stateParams.searchText != null)
            $rootScope.TopBarAction.SearchText = $stateParams.searchText;
        else
            $rootScope.TopBarAction.SearchText = "";

        if ($rootScope.TopBarAction.isActive == 'true')
            $scope.showDetail('rechercher');
        else
            $scope.closeDetail('rechercher');



        if ($stateParams.mcd != null) {
            vm.ParamMcd = $stateParams.mcd;
        }
        if ($stateParams.qc) {
            vm.ParamQcId = $stateParams.qc;
        }
        else {
            vm.ParamQcId = 10585;
        }

        //Get List 
        var promiseGetList = GroupService.GetGroupList(vm.ParamZoneId, vm.ParamQcId, vm.itemsPerPage, vm.pageno, vm.sortKey, vm.reverse, $rootScope.LangForWork, $rootScope.TopBarAction.isActive, $stateParams.search, $stateParams.gsearch, $stateParams.searchText, vm.SearchVM);
        promiseGetList.then(function (response) {
            vm.GroupList = response.data.GroupList;  // data to be displayed on current page.
            $rootScope.InitListSelectedId(vm.GroupList, 'set', vm);
            vm.total_count = response.data.total_count; // total data count.
            $rootScope.total_count = response.data.total_count;
            vm.SearchVM = response.data.SearchVM;
            $rootScope.SideBarSearchVM = vm.SearchVM
            //$scope.ChangeZoneById(vm.ParamZoneId);
            $rootScope.TopBarAction.StatusList = $rootScope.StatusList4WorkflowObject;
            $rootScope.TopBarAction.ClientList = angular.copy(vm.SearchVM.Client);
        });
    };

    vm.getData = function (zoneId, ParamQcId, pageno, sortKey, reverse, isTopBarActive, searchText, SearchVM) { // This would fetch the data on page change.
        $window.location.href = $rootScope.interfaceSubFolder +'/#!/list/set?z=' + zoneId + '&qc=' + ParamQcId + '&pageno=' + pageno + '&sortkey=' + sortKey + '&reverse=' + reverse + '&istopbaractive=' + isTopBarActive + '&searchText=' + searchText + '&search=' + $stateParams.search + '&gsearch=' + $stateParams.gsearch;
    };

    vm.getDataV2();

    $scope.$parent.search = $stateParams.search;
    $scope.$parent.gsearch = $stateParams.gsearch;
    $scope.$parent.qc = vm.ParamQcId;
    $scope.$parent.sortkey = vm.sortKey;
    $scope.$parent.reversesort = vm.reverse;


    //  $scope.vm = vm;

    $scope.sort = function (keyname) {
        vm.sortKey = keyname;   //set the sortKey to the param passed
        vm.reverse = !vm.reverse; //if true make it false and vice versa
        vm.getData(vm.ParamZoneId, vm.ParamQcId, vm.pageno, keyname, vm.reverse, $rootScope.TopBarAction.isActive, $rootScope.TopBarAction.SearchText, vm.SearchVM);
    }

    vm.getUserUrl = function (setId, lang, index, sortKey, reverse, itemZoneId) {
        var urlDynamique = '/#!/consultation/set?id=';
        if ($rootScope.globals.currentUser.RoleId == $rootScope.EnumRole.Author) {
            urlDynamique = "/#!/consultation/set?id=";
        }
        if ($rootScope.globals.currentUser.RoleId == $rootScope.EnumRole.Corrector) {
            urlDynamique = "/#!/correction/set?id=";
        }
        if ($rootScope.globals.currentUser.RoleId == $rootScope.EnumRole.Translator) {
            urlDynamique = "/#!/traduction/set?lang2=" + $rootScope.LangForTranslationDestination + "&id=";
        }
        return $rootScope.interfaceSubFolder + urlDynamique + setId + "&qc=" + vm.ParamQcId + "&lang=" + lang + "&index=" + index + "&sortKey=" + sortKey + "&reverse=" + reverse + "&z=" + itemZoneId;
    }

    $rootScope.AdvancedSearch = function AdvancedSearch() {
        $rootScope.TopBarAction.isActive = false;
        $rootScope.resetSelectedListId();
        vm.getsearchurlparam(vm.ParamZoneId, vm.pageno, vm.sortKey, vm.reverse, $rootScope.TopBarAction.isActive, $rootScope.TopBarAction.SearchText, $rootScope.SideBarSearchVM);
    };


    $rootScope.GlobalAdvancedSearch = function GlobalAdvancedSearch(key, value) {
        if (value != null) {
            $rootScope.SideBarSearchVM.GlobalSearch.SearchValues[key] = value;
            $rootScope.SideBarSearchVM.GlobalSearch.Keyword = "";
            $rootScope.AdvancedSearch();
        }
    };

    $rootScope.removeTags = function (key) {
        //$rootScope.SideBarSearchVM.GlobalSearch.SearchValues.splice(key, 1);
        delete $rootScope.SideBarSearchVM.GlobalSearch.SearchValues[key];
        $rootScope.AdvancedSearch();
        //$rootScope.$apply();
    };

    $rootScope.ShowResultBeforeReplace = function () {
        $rootScope.TopBarAction.isActive = true;
        vm.getData(vm.ParamZoneId, vm.ParamQcId, vm.pageno, vm.sortKey, vm.reverse, $rootScope.TopBarAction.isActive, $rootScope.TopBarAction.SearchText, $rootScope.SideBarSearchVM);
    }

    $rootScope.BatchReplaceText = function () {
        $rootScope.TopBarAction.IdList = GetSelectedIdList(vm.GroupList, 'Id');
        $rootScope.TopBarAction.ObjectType = $rootScope.EnumLinkType.Group;
        $rootScope.TopBarAction.Lang = $rootScope.LangForWork;
        if ($rootScope.TopBarAction.IdList.length > 0 && $rootScope.TopBarAction.SearchText != undefined && $rootScope.TopBarAction.ToReplaceText != undefined) {
            SideBarService.BatchReplaceText($rootScope.TopBarAction)
            .then(
                    function success(data) {
                    },
                    function error(data) { });
        }
    }

    $rootScope.BatchModifyClient = function () {
        $rootScope.TopBarAction.IdList = GetSelectedIdList(vm.GroupList, 'Id');
        $rootScope.TopBarAction.ObjectType = $rootScope.EnumLinkType.Group;
        $rootScope.TopBarAction.Lang = $rootScope.LangForWork;

        SideBarService.BatchModifyClient($rootScope.TopBarAction)
        .then(
                function success(data) {
                    window.location.reload();
                },
                function error(data) { });
    }

    $rootScope.BatchModifyStatus = function () {
        $rootScope.TopBarAction.IdList = GetSelectedIdList(vm.GroupList, 'Id');
        $rootScope.TopBarAction.ObjectType = $rootScope.EnumLinkType.Group;
        $rootScope.TopBarAction.Lang = $rootScope.LangForWork;

        SideBarService.BatchModifyStatus($rootScope.TopBarAction)
        .then(
                function success(data) {
                    window.location.reload();
                },
                function error(data) { });
    }
};